'use client';

import { useEffect } from 'react';

import { initializeFetchInterceptor } from '@/lib/fetchInterceptor';

/**
 * Client component that initializes the fetch interceptor
 * Must be used in a Server Component to ensure it runs on the client
 */
export function FetchInterceptorInit() {
  useEffect(() => {
    initializeFetchInterceptor();
  }, []);

  return null;
}
